import React, { useContext, useEffect, useState } from 'react';
import { getCategory, createCategory, updateCategory, deleteCategory } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css'
import { EditCategory } from './Form';
import { Deletemodel, Pagination } from "../../Common/Functions"
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';
import { useLocation } from 'react-router-dom';

const Category_list = () => {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader, selectedWarehouse, shopItem } = useContext(WarehouseContext);
    const [ware_id] = useState(selectedWarehouse?.id);
    const [shop_id] = useState(shopItem?.id);
    const [category, setCategory] = useState([]);
    const [formData, setFormData] = useState({ category: '', status: '' });
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [addoredit, setaddoredit] = useState();
    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;

    useEffect(() => {
        fetchCategory();
    }, []);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    }

    const fetchCategory = async (page = currentPage, text = "") => {
        showLoader();
        try {
            const response = await getCategory(page, text);
            if (response.data && response.data.data) {
                setCategory(response.data.data);
                setTotalPages(response.data.pagination.total_pages);
                hideLoader();
            }
        } catch (error) {
            console.error('Error fetching category data:', error);
            hideLoader();
        }
    };

    const openAddModal = () => {
        setaddoredit(true)
        setShowEditModal(!showEditModal)
    };

    const openEditModal = (cat) => {
        setSelectedCategory(cat);
        setaddoredit(false)
        setShowEditModal(!showEditModal)
    };

    useEffect(() => {
        console.log('data', formData)
    }, [formData]);


    // Delete a category
    const handleDelete = async () => {
        try {
            await deleteCategory(deleteID);
            showDeletemodel(false);
            toast.error('Category  Inactivated');
            fetchCategory(currentPage);
        } catch (error) {
            console.error('Error deleting category:', error);
            toast.error('Error deleting category');
        }
    };

    // Pagination logic
    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchCategory(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchCategory(1, text);
        setCurrentPage(1)
    };

    const activateCategory = async (value) => {
        showLoader();
        try {
            console.log(value);
            const payload = {
                ...value,
                status: 0,
            };
            const res = await updateCategory(value.id, payload)
            hideLoader();
            await fetchCategory(currentPage)
            toast.success('Category Activated')

        } catch (err) {
            console.error(err);
            toast.error(err.message)
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Category List</h6>
                    {!readonly && <button
                        type="button"
                        onClick={() => openAddModal()}
                        className="btn btn-primary mb-0 text-normal rounded-1"
                    >
                        Add Category
                    </button>}
                </div>
                <hr className='mt-1' />


                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div className="d-flex position-relative" style={{ width: "100%" }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                id="example"
                                className="table table-striped  table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {category.map((cat, index) => (
                                        <tr key={cat.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{cat.Categories}</td>
                                            {/* <td>{cat.status === '1' ? 'Active' : 'Inactive'}</td> */}
                                            {/* <td>{new Date(cat.create_date).toLocaleDateString()}</td>
                                            <td>{new Date(cat.update_date).toLocaleDateString()}</td> */}
                                            {!readonly && <td>
                                                {cat.status == null || cat.status == 0 ? (
                                                    <>
                                                        <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(cat)} height="16px" alt="Edit" />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <img src='/assets/images/icons/delete.png' className="mx" onClick={() => handledeletemodel(cat.id)} height="16px" alt="Delete" />
                                                    </>
                                                ) : (
                                                    <button className="btn btn-secondary py-1 rounded-1" style={{ fontSize: '13px' }} onClick={() => activateCategory(cat)}>Inactive</button>
                                                )}
                                            </td>}
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />

                        </div>
                    </div>
                </div>
            </div>
            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )};
            <EditCategory showModal={showEditModal} setShowModal={() => openEditModal()} fetchCategory={() => fetchCategory()} selectedCategory={selectedCategory} AddorEdit={addoredit} />
        </div>
    )
}

export default Category_list